import React, { useEffect, useState } from 'react';
import { MessageCircle, Instagram, Facebook, Sparkles } from 'lucide-react';
import { initPixel, trackWhatsAppClick } from './lib/pixel';
import { LegalModal, LegalDocument } from './components/LegalModal';
import { termsContent, privacyContent } from './components/legalContent';
export function App() {
  const [activeLegalDoc, setActiveLegalDoc] = useState<LegalDocument | null>(null);
  useEffect(() => {
    initPixel();
  }, []);
  const waLink = 'https://wa.me/59995249641';
  const igLink = 'https://www.instagram.com/dushitarot?igsh=NTBzaXM4enhudzZ5&utm_source=qr';
  const fbLink = 'https://www.facebook.com/share/1BTVjr78kF/?mibextid=wwXIfr';
  const testimonials = [{
    quote: "Ricardo a primintí tur kos. Den un siman mi a bolbe ku mi pareha. Mi ta rekomend'é 100%.",
    name: 'M.G.'
  }, {
    quote: 'Tiene un don real. Su lectura fue clara, honesta y muy efectiva.',
    name: 'J.A.'
  }, {
    quote: 'E sa loke e ta hasi. El a duna mi pas i kontesta berdadero. Danki.',
    name: 'L.R.'
  }];
  return <div className="min-h-screen w-full bg-brand-bg font-sans flex flex-col items-center justify-center relative overflow-hidden selection:bg-brand-gold selection:text-brand-bg" data-id="element-0">
      {/* Background image */}
      <div className="absolute inset-0 bg-cover bg-center pointer-events-none" style={{
      backgroundImage: "url('https://cdn.magicpatterns.com/uploads/dFhXHTQUuWXbfx4Z8rCD2B/ChatGPT_Image_11_jun_2026,_11_15_26.png')"
    }} aria-hidden="true" data-id="element-1" />
      {/* Dark overlay for readability */}
      <div className="absolute inset-0 bg-brand-bg/85 pointer-events-none" aria-hidden="true" data-id="element-2" />

      {/* Background glow effects */}
      <div className="absolute top-[-20%] left-[-10%] w-[70%] h-[70%] rounded-full bg-brand-gold/5 blur-[120px] pointer-events-none" data-id="element-3" />
      <div className="absolute bottom-[-20%] right-[-10%] w-[70%] h-[70%] rounded-full bg-brand-gold/5 blur-[120px] pointer-events-none" data-id="element-4" />

      {/* Main Card Container */}
      <div className="w-full max-w-4xl px-6 py-12 md:py-16 flex flex-col items-center text-center z-10 animate-fade-up opacity-0" style={{
      animationDelay: '0.2s'
    }} data-id="element-5">
        {/* Icon / Top Accent */}
        <div className="mb-6 md:mb-8 text-brand-gold animate-scale-in opacity-0" style={{
        animationDelay: '0.6s'
      }} data-id="element-6">
          <Sparkles size={40} strokeWidth={1.5} data-id="element-7" />
        </div>

        {/* Title */}
        <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl font-semibold tracking-wide text-white mb-4 md:mb-6 drop-shadow-2xl leading-tight" data-id="element-8">
          DushiTarot <br className="md:hidden" data-id="element-9" />
          <span className="text-brand-gold italic font-light" data-id="element-10">Videncial</span>
        </h1>

        {/* Tagline */}
        <div className="flex items-center justify-center gap-4 mb-10 md:mb-12 w-full" data-id="element-11">
          <div className="h-[1px] flex-1 max-w-[60px] bg-gradient-to-r from-transparent to-brand-gold/70" data-id="element-12" />
          <h2 className="font-serif text-xl md:text-3xl tracking-[0.2em] text-brand-gold/90 uppercase" data-id="element-13">
            Elígelo · Skohe'é
          </h2>
          <div className="h-[1px] flex-1 max-w-[60px] bg-gradient-to-l from-transparent to-brand-gold/70" data-id="element-14" />
        </div>

        {/* Short Intro */}
        <div className="mb-8 md:mb-10 space-y-2 md:space-y-3" data-id="element-15">
          <p className="text-xl md:text-2xl text-gray-200 font-light tracking-wide" data-id="element-16">
            Tu destino te espera.
          </p>
          <p className="text-lg md:text-xl text-brand-gold/70 font-light tracking-wide italic" data-id="element-17">
            Bo destino ta warda bo.
          </p>
          <p className="text-base md:text-lg text-gray-300 font-light tracking-wide pt-2 max-w-2xl mx-auto" data-id="element-18">
            Amor, plaka i energia: deskubrí kiko ta stroba bo kaminda.
          </p>
        </div>

        {/* Reader / Ricardo */}
        <div className="mb-12 md:mb-16 flex flex-col items-center" data-id="element-19">
          <p className="text-base md:text-lg uppercase tracking-[0.3em] text-gray-400 mb-2" data-id="element-20">
            Vidente
          </p>
          <p className="font-serif text-3xl md:text-5xl text-brand-gold mb-3" data-id="element-21">
            Ricardo
          </p>
          <p className="text-lg md:text-xl text-gray-200 font-light max-w-xl leading-relaxed" data-id="element-22">
            25 años de experiencia en uniones de pareja
          </p>
        </div>

        {/* CTAs */}
        <div className="w-full flex flex-col sm:flex-row gap-5 md:gap-8 justify-center items-center mb-16 md:mb-20" data-id="element-23">
          <a href={waLink} target="_blank" rel="noopener noreferrer" onClick={() => trackWhatsAppClick('es')} className="group w-full sm:w-auto flex items-center justify-center gap-3 bg-brand-gold hover:bg-brand-goldHover text-brand-bg px-8 md:px-10 py-4 md:py-5 rounded-full font-medium text-lg md:text-xl transition-all duration-300 shadow-[0_0_40px_rgba(200,150,46,0.25)] hover:shadow-[0_0_60px_rgba(200,150,46,0.4)] hover:-translate-y-1" data-id="element-24">
            <MessageCircle size={28} className="group-hover:scale-110 transition-transform duration-300" data-id="element-25" />
            <span data-id="element-26">Consulta en Español</span>
          </a>

          <a href={waLink} target="_blank" rel="noopener noreferrer" onClick={() => trackWhatsAppClick('pap')} className="group w-full sm:w-auto flex items-center justify-center gap-3 border-2 border-brand-gold/80 text-brand-gold hover:bg-brand-gold/10 px-8 md:px-10 py-4 md:py-5 rounded-full font-medium text-lg md:text-xl transition-all duration-300 hover:-translate-y-1 hover:border-brand-gold" data-id="element-27">
            <MessageCircle size={28} className="group-hover:scale-110 transition-transform duration-300" data-id="element-28" />
            <span data-id="element-29">Konsulta Papiamento</span>
          </a>
        </div>

        {/* Testimonials */}
        <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-16 md:mb-20" data-id="element-30">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col text-left bg-white/5 border border-brand-gold/20 rounded-2xl p-6 md:p-7 backdrop-blur-sm" data-id="element-31">
              <blockquote className="text-base md:text-lg text-gray-200 font-light leading-relaxed italic mb-4" data-id="element-32">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-3" data-id="element-33">
                <span className="flex items-center justify-center w-9 h-9 rounded-full bg-brand-gold/15 text-brand-gold font-medium text-sm" data-id="element-34">
                  {t.name.replace(/\./g, '')}
                </span>
                <span className="text-sm tracking-wide text-brand-gold/80 font-medium" data-id="element-35">
                  {t.name}
                </span>
              </figcaption>
            </figure>)}
        </div>

        {/* Footer / Socials */}
        <div className="flex flex-col items-center gap-6 md:gap-8 mt-auto w-full" data-id="element-36">
          <div className="flex gap-8" data-id="element-37">
            <a href={igLink} target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-brand-gold transition-colors duration-300 p-2 hover:scale-110 transform" aria-label="Instagram" data-id="element-38">
              <Instagram size={32} strokeWidth={1.5} data-id="element-39" />
            </a>
            <a href={fbLink} target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-brand-gold transition-colors duration-300 p-2 hover:scale-110 transform" aria-label="Facebook" data-id="element-40">
              <Facebook size={32} strokeWidth={1.5} data-id="element-41" />
            </a>
          </div>

          <div className="flex flex-col items-center gap-4" data-id="element-42">
            <div className="flex items-center gap-3 text-gray-600" data-id="element-43">
              <div className="w-1 h-1 rounded-full bg-brand-gold/50" data-id="element-44" />
              <p className="text-sm font-light tracking-[0.3em]" data-id="element-45">CURAÇAO</p>
              <div className="w-1 h-1 rounded-full bg-brand-gold/50" data-id="element-46" />
            </div>

            <div className="flex items-center gap-4 text-xs text-gray-500 font-light" data-id="element-47">
              <button onClick={() => setActiveLegalDoc(termsContent)} className="hover:text-brand-gold transition-colors" data-id="element-48">
                Términos y Condiciones
              </button>
              <span data-id="element-49">|</span>
              <button onClick={() => setActiveLegalDoc(privacyContent)} className="hover:text-brand-gold transition-colors" data-id="element-50">
                Política de Privacidad
              </button>
            </div>
          </div>
        </div>
      </div>

      <LegalModal isOpen={!!activeLegalDoc} onClose={() => setActiveLegalDoc(null)} document={activeLegalDoc} data-id="element-51" />
    </div>;
}